import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingState, ObservableState } from 'src/app/core/constants/observable-state.interface';
import { ServerErrorComponent } from "../server-error/server-error.component";
import { CardLoaderComponent } from "../card-loader/card-loader.component";

@Component({
  standalone: true,
    selector: 'webstore-loading-states-wrapper',
    templateUrl: './loading-states-wrapper.component.html',
    styleUrls: ['./loading-states-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ServerErrorComponent, CardLoaderComponent]
})
export class LoadingStatesWrapperComponent<T> {

  readonly heading = input<string>('');
  readonly state = input.required<ObservableState<T>>();
  LoadingState = LoadingState;

}

